module.exports = __webpack_public_path__ + "05_long_grey.365e3476.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_long_grey.png
// module id = pHgT
// module chunks = 0